import { getScreenNameAuthenticated } from "../../utils/auth/Auth-utils";
import * as FuncionesServices from "../../utils/funciones-services";

export const obtenerPagoRecurrente = async (idSolicitudMultiple) => {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_PAGO_RECURRENTE, atributos),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Content-Type'              : 'application/json',
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'           : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'           : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : getScreenNameAuthenticated()
        })
    })
}

export const actualizarPagoRecurrente = async (idSolicitudMultiple, flagMismoMedioPago, pagoRecurrente) => {
    let atributos = [
    { campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }
    ]
    let parametros = [
    { campo: 'usarMismoMedioPago', valor: flagMismoMedioPago }
    ]
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.agregarParametros(FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_GET_PAGO_RECURRENTE, atributos), parametros),
        method: 'PUT',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Content-Type'              : 'application/json',
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'           : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'           : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : getScreenNameAuthenticated()
        }),
        body: JSON.stringify(pagoRecurrente)
    })
}

export const obtenerOperadores = async (idMedioPago) => {
    let parametros = [
        { campo: 'tipoCobranza', valor: idMedioPago },
    ]

    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.agregarParametros(process.env.REACT_APP_WS_GET_OPERADORES, parametros),
        method: 'GET',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Content-Type'              : 'application/json',
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'           : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'           : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : getScreenNameAuthenticated()
        })
    })
}

export const validarPagoRecurrente = async (pagoRecurrente, idSolicitudMultiple) => {
    let atributos = [{ campo: 'idSolicitudMultiple', valor: idSolicitudMultiple }]
    return FuncionesServices.procesarRespuesta({
        url: FuncionesServices.reemplazarUrlServicio(process.env.REACT_APP_WS_VALIDAR_PAGO_RECURRENTE, atributos),
        method: 'POST',
        headers: new Headers({
            'Ocp-Apim-Subscription-Key' : process.env.REACT_APP_SUSCRIPTION_KEY,
            'Content-Type'              : 'application/json',
            'Authorization'             : 'Bearer ' + FuncionesServices.getAccessToken(),
            'transactionId'             : FuncionesServices.generarCorrelativo(),
            'correlationId'             : FuncionesServices.generarCorrelativo(),
            'businessProcess'           : process.env.REACT_APP_BUSINESS_PROCESS,
            'applicationName'           : process.env.REACT_APP_NOMBRE_APLICACION,
            'applicationUser'           : getScreenNameAuthenticated()
        }),
        body: JSON.stringify(pagoRecurrente)
    })
}